"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var RangeSliderHandle = function RangeSliderHandle(_ref) {
  var value = _ref.value,
      offset = _ref.offset,
      prefix = _ref.prefix,
      suffix = _ref.suffix;
  var styles = {
    left: "".concat(offset, "%")
  };
  return _react.default.createElement("div", {
    className: "RangeSliderHandle-container",
    style: styles
  }, _react.default.createElement("div", {
    className: "RangeSliderHandle"
  }), _react.default.createElement("div", {
    className: "RangeSliderHandle-label"
  }, prefix, value, suffix));
};

var _default = RangeSliderHandle;
exports.default = _default;